import { useMemo } from "react";
import { Title } from "../../../../../../styles/page";
import { isGTDType } from "../../../../../../utils/tournament-type";
import { usePointPaid } from "../../hook/usePointPaid";
import {
  PointPaidHeader,
  PointPaidPopupWrapper,
  PointPaidTableHeader,
  PointPaidTableListWrapper,
  PointPaidTableWrapper,
} from "../../style";
import SearchMemberPopup from "../search-member";
import PointPaidItem from "../point-paid-item";

interface PointPaidPopupProps {
  tournamentId: number;
  getData: () => void;
  onClose: () => void;
}

const PointPaid = ({ tournamentId, getData, onClose }: PointPaidPopupProps) => {
  const hook = usePointPaid({
    tournamentId,
    getData,
  });
  const {
    allPrizeList,
    setAllPrizeList,
    tournament,
    totalSeedAmount, // 시상 가능 시드 전체
    totalPointAmount, // 시상 가능 매장 이용권 전체
    isSearch,
    setIsSearch,
    selectRank,
    setLocalStorage,
  } = hook;
  const isGtd = isGTDType(tournament?.tournamentType);
  const minSeed = Math.round(totalSeedAmount * 0.9);
  const maxSeed = Math.round(totalSeedAmount * 1.1);
  // 시상 총 시드 (데일리)
  const totalSeed = useMemo(() => {
    return allPrizeList.reduce(
      (acc, curr) => (acc += curr.payMent ? curr.totalPrize : 0),
      0,
    );
  }, [allPrizeList]);

  // 시상 가능 매장이용권 (GTD)
  const totalPoint = useMemo(() => {
    const sumPointPrize = allPrizeList.reduce(
      (acc, curr) => (acc += curr?.pointPrize || 0),
      0,
    );
    return totalPointAmount - sumPointPrize;
  }, [totalPointAmount, allPrizeList]);

  // 팝업 닫을 때 핸들러
  const handleClose = () => {
    // 전체 등수 시상 완료 됐을 시 로컬에서 삭제
    if (!allPrizeList.some((item) => !item.payMent)) {
      localStorage.removeItem(`tournament_${tournamentId}`);
    } else {
      // 로컬에 현재 내용 저장
      setLocalStorage(allPrizeList);
    }
    onClose();
  };

  const getHeaderText = () => {
    if (isGtd) {
      return `(시상 가능 총 매장이용권 : ${totalPoint} E)`;
    } else {
      return `(시상 가능 총 프라이즈 범위 : ${minSeed}~${maxSeed} | 시상 완료 : ${totalSeed})`;
    }
  };

  const headers = [
    { name: "순위", className: "rank" },
    { name: `토탈 프라이즈 ${isGtd ? "(+추가시상)" : ""}`, className: "value" },
    { name: "매장이용권", className: "value" },
    { name: "캐럿", className: "value" },
    { name: "부상", className: "value" },
    { name: "부상 갯수", className: "value" },
    { name: "래빗", className: "value" },
    { name: "닉네임", className: "nickname" },
    { name: "", className: "button" },
  ];

  return (
    <>
      {isSearch && (
        <SearchMemberPopup
          prizeList={allPrizeList}
          setPrizeList={setAllPrizeList}
          index={selectRank === null ? -1 : selectRank}
          onClose={() => setIsSearch(false)}
          tournamentId={tournamentId}
        />
      )}
      <PointPaidPopupWrapper>
        <PointPaidHeader>
          <Title>
            시상
            <span>{getHeaderText()}</span>
          </Title>
          <div className="right">
            {isGtd ? (
              <div className="info">
                *GTD 토너먼트의 경우 프라이즈 합산의 30%이내로 매장이용권 시상이
                가능
              </div>
            ) : (
              <div className="info">
                *토탈프라이즈의 +-10% 범위 내에서 시상이 가능합니다.
              </div>
            )}
            <img
              src="/image-web/solution/close.svg"
              alt="close"
              onClick={handleClose}
            />
          </div>
        </PointPaidHeader>
        <PointPaidTableWrapper>
          <PointPaidTableHeader>
            {headers.map((header, index) => (
              <div key={index} className={`item ${header.className}`}>
                {header.name}
              </div>
            ))}
          </PointPaidTableHeader>
          <PointPaidTableListWrapper>
            {allPrizeList.map((item, index) => (
              <PointPaidItem
                item={item}
                index={index}
                hook={hook}
                isGTD={isGTDType(tournament?.tournamentType)}
              />
            ))}
          </PointPaidTableListWrapper>
        </PointPaidTableWrapper>
      </PointPaidPopupWrapper>
    </>
  );
};

export default PointPaid;
